import { ActivatedRouteSnapshot, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

export interface Breadcrumb {
  label: string;
  routerLink: RouterLink['routerLink'];
}

export interface BreadcrumbsRouteData {
  breadcrumb: string;
}

export abstract class BreadcrumbsService {
  public abstract readonly items: Observable<Breadcrumb[]>;
  public abstract updateBreadcrumbLabel?(route: ActivatedRouteSnapshot, label: string): void;
  public abstract updateItems(items: Breadcrumb[]): void;
}
